import { PentestStatus, PentestType, Severity } from '../enums';
import { BoxLight } from './box-light';
import { ScanResultType } from '../enums/scan-result-type.enum';

export interface PentestScan {
  id: string;
  name: string;
  type: PentestType;
  status: PentestStatus;
  createdAt: string;
  completedAt: string;
  canceledAt: string;
  durationS: number;
  nodeZeroIp: string;
  impactsCount: number;
  weaknessesCount: number;
  credentialsCount: number;
  hostsCount: number;
  runner: BoxLight;
  fromNessus: boolean;
  historyId: string;
  resultStatus: Severity;
  scanResultType: ScanResultType;
}

export namespace PentestScan {
  export function mapFromApiValue(pentestScan: any): PentestScan {
    const { type, status, scanResultType, ...restOfPentestScan } = pentestScan;
    return {
      ...restOfPentestScan,
      type: PentestType.mapFromApiValue(type),
      status: PentestStatus.mapFromApiValue(status),
      resultStatus: undefined,
      scanResultType: ScanResultType.mapFromApiValue(scanResultType),
    };
  }
}
